import React from 'react'
import { Helmet } from 'react-helmet-async'
import CaySamNFTView from 'src/sections/caysam/view/cay-sam-details'

export const PageCaySamNFC = () => (
    <>
    <Helmet>
        Thông tin cây sâm
    </Helmet>
    <CaySamNFTView/>
    </>
  )
